import { render, staticRenderFns } from "./addLessons.vue?vue&type=template&id=32102678&"
import script from "./addLessons.vue?vue&type=script&lang=js&"
export * from "./addLessons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports